import React from 'react';

import { Button, Icon, Tooltip } from '@chakra-ui/react';
import { FiSidebar } from 'react-icons/fi';

/**
 * "Follow along": docks the page beside the app screen it describes, so
 * readers can do each step without switching between docs and app.
 */
export const DocumentationFollowAlongButton = ({
  onClick,
}: {
  onClick: () => void;
}) => (
  <Tooltip
    label="Keep this guide open beside the app while you work"
    placement="bottom-start"
  >
    <Button
      mt={4}
      size="sm"
      variant="outline"
      colorScheme="purple"
      fontWeight={400}
      leftIcon={<Icon as={FiSidebar} />}
      onClick={onClick}
    >
      Follow along
    </Button>
  </Tooltip>
);
